module.exports = __webpack_public_path__ + "img/aer.0e9644cb.png";